import clsx from 'clsx';
import React from 'react';

function TextAreaInput(props) {
  const { isError, errorMessage, label, prefix, isRequired, rows, ...restProps } = props;
  return (
    <div className="form-group">
      <label>
        {label} {isRequired && <span className="text-danger fw-600">*</span>}
      </label>
      <textarea
        {...restProps}
        rows={rows ? rows : 5}
        className={clsx('form-control', { 'border-danger': isError })}
      />
      {isError && errorMessage && (
        <span className="text-danger text-14 fw-normal">{errorMessage}</span>
      )}
    </div>
  );
}

export default TextAreaInput;
